<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3 *ngIf="city_id == '0'">શહેર ઉમેરો</h3>
            <h3 *ngIf="city_id !=  '0'">શહેર બદલો</h3>
        </div>
    </div>
</header>
<main>
    <div class="loginWraper">
        <form [formGroup]="cityForm">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12">
                        <input type="text" class="form-control" placeholder="શહેર" formControlName="city_name" />
                        <div *ngIf="submitted && f.city_name.errors" class="error-message">
                            <small *ngIf="f.city_name.errors?.required" class="text-danger">શહેરનું નામ જરૂરી
                                છે.</small>
                        </div>
                    </div>
                    <!-- <input #passwordInput type="password" class="form-control" placeholder="Password" />
                    <span (click)="togglePasswordVisibility(passwordInput)" class="eye-icon"></span> -->
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12">
                        <select class="form-control" formControlName="country_name" [(ngModel)]="selectedCountryName">
                            <option hidden value="" disabled selected>દેશ</option>
                            <option value="ભારત">ભારત</option>
                            <option value="અન્ય(NRI)">અન્ય(NRI)</option>
                        </select>
                    </div>
                </div>
            </div>
            <!-- <div *ngIf="submitted && f.current_city_id.errors" class="error-message">
                    <small *ngIf="f.current_city_id.errors?.required" class="text-danger">શહેર જરૂરી છે.</small>
                </div>         -->
            <button type="submit" class="btn-common" (click)="cityAdd()">સાચવો</button>

        </form>
    </div>
</main>